import levelTwoiImage from '../../constants/imageFiles/levelTwoiImage.jpeg';
import { Grid } from '@mui/material'
import AnswerBox from '../AnswerBox';

export default function LevelTwoi() {
    console.log("AI hasn't quite mastered the Aardvark wearing glasses and polo shirt technology.")
    return (
        <div>


            <Grid container spacing={1} alignItems='center' justifyContent="center">
                <Grid item xs={9}>
                    <img
                        style={{ maxWidth: "100%" }}
                        src={levelTwoiImage}
                        alt="An aardvark with glasses and a red polo."
                    />
                </Grid>
            </Grid>
            <br></br>
            < AnswerBox 
                            correctAnswer = 'arthur'
                            hint = {<div>Need aanother hint?</div>}
                            nextLevel = '../levels/level2j'
                            />
        </div>
    )
};